import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive } from "vue";
import { MappingGenerationResultModel } from "@medapro-types/ChannelCreator/components/AutoMappingTab";

//#region General
type ViewModel = { showModal: boolean };

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoMappingSummary',
  props: {
    summary: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;


//#endregion

//#region ViewModel
const viewModel = reactive<ViewModel>({ showModal: false });
//#endregion

//#region Methods
const show = () => {
  viewModel.showModal = true;
};
__expose({
  show: show
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    ref: "summary",
    title: _ctx.$t('Automapping.AutomappingShowStatisticsTitle'),
    modelValue: viewModel.showModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.showModal) = $event)),
    "data-cy": "channel-creator-automapping-summary-modal"
  }, {
    "modal-footer": _withCtx(({ ok }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        "data-cy": "channel-creator-automapping-summary-close-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("Close")), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_b_container, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t("AutoMapping.Summary.Subtitle")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AutoMapping.Summary.catalogMappingsCount")) + " :", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_col, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.summary.catalogMappingsCount ?? 0), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AutoMapping.Summary.globalMappingsCount")) + " :", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_col, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.summary.globalMappingsCount ?? 0), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AutoMapping.Summary.invariantAttributeMappingsCount")) + " :", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_col, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.summary.invariantAttributeMappingsCount ?? 0), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AutoMapping.Summary.variantAttributeMappingsCount")) + " :", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_col, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.summary.variantAttributeMappingsCount ?? 0), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})